import { createReducer, on } from "@ngrx/store";
import { GetLearningRecord, GetLearningRecordByLearnerId, GetLearningRecordError, ResetPanelState, SetSelectedCourse, SetTabState, UpdateTabState } from "./learning-record-tab.actions";
import { LearningRecordTabState, initialLearningRecordTabState } from "./learning-record-tab.state";
import { getPanelState } from "./learning-record-tab.utils";

export const LearningRecordTabReducer = createReducer(
    initialLearningRecordTabState,

    on(SetTabState, (state, action): LearningRecordTabState => {
        return {
            ...state,
            loading: false,
            panelState: getPanelState(state, action)
        }
    }),
    on(UpdateTabState, (state, action): LearningRecordTabState => {
        return {
            ...state,
            panelState: state.panelState.map((tab => 
                (tab.objectId === action.objectId && tab.skill === action.skill ) ? { ...tab, expanded: !tab.expanded } : tab    
            ))
        }
    }),
    on(SetSelectedCourse, (state, action): LearningRecordTabState => {
        return { 
            ...state,
            panelState: (action.courseId == state.course) ? state.panelState : [],
            course: action.courseId
            
        }
    }),
    on(GetLearningRecord, (state, action): LearningRecordTabState => {
        return {
            ...state,
            loading: true,
            course: action.courseId,
            error: false
        }
    }),
    on(GetLearningRecordByLearnerId, (state, action): LearningRecordTabState => {
        return {
            ...state,
            loading: true,
            course: action.courseId,
            error: false
        }
    }),
    on(GetLearningRecordError, (state): LearningRecordTabState => {
        return {
            ...state,
            loading: false,
            error: true
        }
    }),
    on(ResetPanelState, (state): LearningRecordTabState => {
        return {
            ...state,
            panelState: []
        }
    })
)

